<template>
  <div v-if="displayWelcomeMessage && isCardVisible" class="row">
    <div class="col">
      <b-card class="border" no-body>
        <b-card-body class="p-3 p-md-4 bg-white rounded shadow card-top__accent">
          <div class="row">
            <div class="col-md-11 m-auto font-size-14">
              <template v-if="companyClosed">
                <i18n path="accountClosed" tag="p" class="my-3">
                  <template #forename>
                    <span v-if="forename">&nbsp;{{ forename }}</span>
                  </template>
                  <template #accountManagementTeamLinkText>
                    <router-link class="text-link text-link-reset" :to="{name: 'contact'}">
                      {{ $t('accountManagementTeamLinkText') }}
                    </router-link>
                  </template>
                </i18n>
              </template>
              <template v-else-if="showValidate">
                <h2 class="h4 pt-3">
                  {{ $t('Before you can buy leads, we need to verify your email address.') }}
                </h2>
                <p>{{ $t('checkVerificationEmail', {userEmail}) }}</p>
                <b-button size="sm" class="mb-3" @click="$emit('sendToken')">
                  {{ $t('Resend Verification Email') }}
                </b-button>
                <b-alert :show="validationResendTimer !== null" variant="warning">
                  {{ $t('validationTimer', {validationResendTimer}) }} 
                </b-alert>
                <b-alert :show="validationSuccess" variant="success">
                  {{ $t('Email sent, please check your inbox') }}
                </b-alert>
              </template>
              <template v-else-if="daysSinceCompanyCreated > 30">
                <i18n path="dashboardGreeting" tag="p" class="my-1 my-md-3">
                  <template #forename>
                    <span v-if="forename">&nbsp;{{ forename }}</span>
                  </template>
                  <template #feedbackFeatureLinkText>
                    <a href="#" class="text-link font-weight-bold" @click.prevent="showFeedbackTooltip">{{ $t('feedbackFeatureLinkText') }}</a>
                  </template>
                </i18n>
              </template>
              <template v-else-if="companyAccountIsActive">
                <b-button class="position-absolute dismiss-welcome" variant="empty" @click.stop="removeMessage">
                  <font-awesome-icon icon="times" />
                </b-button>
                <i18n path="accountIsSetUp" tag="p" class="my-1 my-md-3">
                  <template #forename>
                    <span v-if="forename">&nbsp;{{ forename }}</span>
                  </template>
                  <template #helpCentreLinkText>
                    <div></div>
                  </template>
                  <template #getInTouchLinkText>
                    <router-link class="text-link text-link-reset" :to="{name: 'contact'}">
                      {{ $t('getInTouchLinkText') }}
                    </router-link>
                  </template>
                </i18n>
              </template>
            </div>
          </div>
        </b-card-body>
      </b-card>
    </div>
  </div>
</template>

<script>
import {HIDE_WELCOME_MESSAGE} from "@/store/mutation-types";
import dates from "@/services/date";

const ACCOUNT_CLOSED_STATUS = 230
const ACCOUNT_ACTIVE_STATUS = 20;

export default {
  name: "HomeMessageBlock",
  props: ['showValidate', 'validationResendTimer', 'companyUser', 'companyCreated', 'companyStatus'],
  data: function() {
    return {
      validationSuccess: false,
      isCardVisible: true,
    }
  },
  computed: {
    forename: function () {
      const {forename} = this.companyUser;
      return forename;
    },
    userEmail: function () {
      const {email} = this.companyUser;
      return email;
    },
    daysSinceCompanyCreated: function() {
      if (this.companyCreated === null) {
        return 31;
      }
      return dates.diffDays(new Date(), new Date(this.companyCreated));
    },
    companyClosed: function() {
      return (this.companyStatus) ? (this.companyStatus.id === ACCOUNT_CLOSED_STATUS) : false;
    },
    hideWelcomeMessage: {
      get: function() {
        return this.$store.state.HIDE_WELCOME_MESSAGE;
      },
      set: function(value) {
        this.$store.commit(HIDE_WELCOME_MESSAGE, value);
      }
    },
    displayWelcomeMessage: function() {
      if (this.hideWelcomeMessage !== undefined) {
        return this.hideWelcomeMessage && !this.isCardVisible;
      }
      return true;
    },
    companyAccountIsActive: function () {
      if (this.companyStatus) {
        return this.companyStatus.id === ACCOUNT_ACTIVE_STATUS;
      }
      return false;
    },
  },
  methods: {
    toggleValidationSuccess: function(value) {
      this.validationSuccess = value;
    },
    showFeedbackTooltip: function() {
      this.$root.$emit('bv::show::tooltip', 'feedback-tooltip');
    },
    removeMessage: function() {
      this.isCardVisible = false;
      this.hideWelcomeMessage = true;
    }
  }
}
</script>

<style scoped>
.dismiss-welcome {
  right: 0;
  top: -10px;
}
</style>
